<template>
  <section class="sky-language">
    <header>
      <div class="flow-btn">
        <button @click.prevent="$emit('back')">{{ $t('buttons.back') }}</button>
      </div>
      <div class="title">
        <h1>{{ $t(`sky.title.${title}`) }}:</h1>
        <p v-if="title === 'enDisabled'">This information is pulled in via Sky, therefore it is read-only.</p>
        <p v-else-if="hasDisabledFields">Some of this information is pulled in via Sky, therefore it is read-only.</p>
      </div>
      <div class="flow-btn">
        <button :class="{ 'alt-btn': !isFilledOut }" @click.prevent="nextStep">{{ $t(nextLabel) }}</button>
      </div>
    </header>
    <div class="fields">
      <div v-for="field in this.fields" :key="field.id" class="field" :class="field.disabled ? 'disabled' : ''">
        <label :for="field.id">{{ field.label }} ({{ language | lang }}):</label>
        <textarea
          v-if="field.type === 'textarea'"
          :id="field.id"
          :placeholder="field.placeholder"
          v-model="field.value"
          :disabled="field.disabled"
          :maxlength="field.maxlength"
        ></textarea>
        <template v-else-if="field.type === 'file'">
          <!-- <dropzone
            v-else-if="field.type === 'file'"
            :value="field.value"
            :image-width="field.width"
            :image-height="field.height"
            :screen-width="field.screenWidth"
            :screen-height="field.screenHeight"
            :screen-offset-top="field.offsetTop"
            :screen-offset-left="field.offsetLeft"
            :preview-src="field.previewSrc"
            :viewonly="viewonly"
            :background="field.backgroundColor"
            @input="imageUpdated($event, index)"
            @upload-key="fileUpdated($event, index)"
          /> -->
          <dropzone
            :key="`${objectId}-${language}-${field.id}`"
            :value="field.value"
            :accepted-files="field.acceptedFiles"
            :image-width="field.width"
            :image-height="field.height"
            :screen-width="field.width"
            :screen-height="field.height"
            :viewonly="viewonly"
            mode="server"
            @input="imageUpdated($event, field)"
            @upload-key="uploadKey($event, field)"
            @cropdata="saveCropdata($event, field)"
          />
          <div v-if="field.note" class="note">{{ field.note }}</div>
        </template>
        <input
          v-else
          :type="field.type"
          :id="field.id"
          :placeholder="field.placeholder"
          v-model="field.value"
          :disabled="field.disabled"
          :maxlength="field.maxlength"
        />
      </div>
    </div>
    <!-- <div class="toggle-buttons">
      <toggle-button v-for="tag in tags" :key="tag.id" v-model="tag.checked" :label="$t('tags.' + tag.id)" @input="checkType(tag)"></toggle-button>
    </div>-->
  </section>
</template>

<script>
import Dropzone from '@/components/Dropzone'
// import { SAVE_MEDIA } from '@/store/actions.type'
// import { TOGGLE_TAGS_CHECKED } from '@/store/mutations.type'
// import { mapGetters } from 'vuex'

export default {
  name: 'sky-language',
  components: {
    Dropzone
  },
  props: {
    language: {
      type: String,
      default: 'en-US'
    },
    fields: {
      type: Array,
      default: () => []
    },
    viewonly: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      tags: JSON.parse(JSON.stringify(this.$store.getters.tags))
    }
  },
  computed: {
    objectId() {
      return this.$route.params.id
    },
    hasDisabledFields() {
      return this.fields.some(field => field.disabled)
    },
    title() {
      if (this.language === 'en-US') {
        if (this.fields.every(field => field.disabled)) {
          return 'enDisabled'
        }
      }
      return this.language
    },
    nextLabel() {
      return this.isFilledOut ? 'buttons.continue' : 'buttons.skipForNow'
    },
    isFilledOut() {
      return this.fields.every(field => {
        return field.value && field.value !== ''
      })
    }
  },
  methods: {
    nextStep() {
      // this.$store.commit(TOGGLE_TAGS_CHECKED, this.tags)
      // this.$store.dispatch(SAVE_MEDIA, false)
      this.$emit('next')
    },
    checkType(tag) {
      this.dirty = true
      if (tag.type && tag.checked) {
        this.tags.forEach(aTag => {
          if (aTag !== tag && aTag.type === tag.type) {
            this.$set(aTag, 'checked', false)
          }
        })
      }
    },
    imageUpdated(file, field) {
      field.image = file
    },
    uploadKey(file, field) {
      field.value = file
    },
    saveCropdata(data, field) {
      field.cropdata = data;
    }
  },
  filters: {
    lang(language) {
      if (language === 'en-US') return 'English US'
      else if (language === 'en-CA') return 'English CA'
      else if (language === 'fr-CA') return 'French'
      else if (language === 'es-MX') return 'Spanish'
    }
  }
}
</script>

<style lang="scss" scoped>
.fields {
  text-align: left;
  margin: auto;
  width: 400px;
}
.field {
  margin-bottom: 45px;

  label {
    font-weight: 300;
  }
  .note {
    font-size: 12px;
    margin-top: 10px;
    opacity: 0.5;
  }
  &.disabled {
    opacity: 0.5;
  }
}
textarea {
  height: 1.43em;
}
</style>
